export const environment = {
  production: false,
  staging: true,

  api: 'https://test.api.id.asvz.ch/api',

  oauth2Config: {
    issuer: 'https://test.idp.asvz.ch',
    redirectUri: 'https://test.id.asvz.ch/auth',
    clientId: '', //TODO
    responseType: 'code',
    scope: 'openid profile email', //offline_access api pid
    showDebugInformation: true,
    timeoutFactor: 0.01,
    checkOrigin: false,
    postLogoutRedirectUri: 'https://test.id.asvz.ch/logout-complete'
  },
  externalLogin: {
    idpIds: {
      // test.idp.asvz.ch
      eduId: '343613707206566144',
      legacyId: '343659829098718746'
    },
    successUrl: '/login/idp/success',
    failureUrl: '/login/idp/fail'
  },
  onlinedeskUrl: 'https://test.schalter.asvz.ch/tn/'
};
